import { Tooltip, withStyles } from 'vopay';
import styleSheet from './LinkedAccountsBadge.module.scss';

const cn = withStyles(styleSheet);

interface LinkedAccountsBadgeProps {
  accounts: string[];
}

const LinkedAccountsBadge = ({ accounts }: LinkedAccountsBadgeProps) => {
  if (accounts.length === 0) return null;

  return (
    <Tooltip
      customElement={<span className={cn('badge')}>{accounts.length} Accounts</span>}
      hasButton={false}
      type="hover"
      position="bottom"
      information={
        <div className={cn('tooltipContent')}>
          <strong className={cn('tooltipTitle')}>{accounts.length} Accounts</strong>
          <ul className={cn('accountList', 'scrollbar')}>
            {accounts.map((account) => (
              <li key={account}>{account}</li>
            ))}
          </ul>
        </div>
      }
    />
  );
};

export default LinkedAccountsBadge;
